// Open Price Item Feature
// @link https://shift4.atlassian.net/wiki/spaces/venuenext/pages/1551138817
export const OPEN_PRICE_ITEM_DISPLAY = '$_____'
export const OPEN_PRICE_REASON = 'Open Price Item'
export const PRICE_ADJUST_REASON = 'Price Adjustment'
